<ng-container [formGroup]="form">
  <mat-form-field>
    <input
      formControlName="selectedSource"
      type="text"
      [placeholder]="'dataCollection.FilterExportDialog.Fields.SourceSlug' | translate"
      matInput
      [matAutocomplete]="auto"
      autocomplete="off"
      [matAutocompleteDisabled]="!companySlug"
    >
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSourceChange($event)"
                      [displayWith]="displaySourceProperty">
      <mat-option *ngFor="let source of filteredSourcesData$ | async" [value]="source">
        {{ source.Slug }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</ng-container>

